import { type Commands } from '../../../core/context/commands';
import { UUID } from '../../../core/context/uuid/entity';
import { ThreatVectorMitigationTasks } from './repository';
import { ThreatVectorMitigationTask } from './entity';
import { type ThreatVectorMitigationTaskData } from './dto';

export class ThreatVectorMitigationTasksCommands
    implements
        Commands<
            ThreatVectorMitigationTasks,
            ThreatVectorMitigationTask,
            ThreatVectorMitigationTaskData
        >
{
    addAll(
        repo: ThreatVectorMitigationTasks,
        data: ThreatVectorMitigationTaskData[],
    ): ThreatVectorMitigationTasks {
        data.forEach((threatVectorMitigationTaskData) => {
            this.add(repo, threatVectorMitigationTaskData);
        });
        return repo;
    }

    add(
        repo: ThreatVectorMitigationTasks,
        data: ThreatVectorMitigationTaskData,
    ): ThreatVectorMitigationTasks {
        const threatVectorMitigationTask = new ThreatVectorMitigationTask({
            ...data,
            deadline: data.deadline ? new Date(data.deadline) : undefined,
        });
        repo.add(threatVectorMitigationTask);
        return repo;
    }

    update(
        repo: ThreatVectorMitigationTasks,
        entity: ThreatVectorMitigationTask,
    ): ThreatVectorMitigationTask {
        repo.update(entity);
        return entity;
    }

    remove(repo: ThreatVectorMitigationTasks, id: string): void {
        repo.remove(id);
    }

    create(
        repo: ThreatVectorMitigationTasks,
        data: Omit<ThreatVectorMitigationTaskData, 'id'>,
    ): ThreatVectorMitigationTask {
        const uuid = new UUID();
        const threatVectorMitigationTask = new ThreatVectorMitigationTask({
            id: uuid.toString(),
            ...data,
            deadline: data.deadline ? new Date(data.deadline) : undefined,
        });
        repo.add(threatVectorMitigationTask);
        return threatVectorMitigationTask;
    }

    fromJSON(
        entity: ThreatVectorMitigationTask[],
        changeCallback: () => void,
    ): ThreatVectorMitigationTasks {
        const newThreatVectorMitigationTasks = new ThreatVectorMitigationTasks(
            changeCallback,
        );
        entity.forEach((threatVectorMitigationTask) => {
            newThreatVectorMitigationTasks.add(
                new ThreatVectorMitigationTask({
                    ...threatVectorMitigationTask,
                    deadline: threatVectorMitigationTask.deadline
                        ? new Date(threatVectorMitigationTask.deadline)
                        : undefined,
                }),
            );
        });
        return newThreatVectorMitigationTasks;
    }
}
